@if (loginStateService.showLogin) {
  <app-login-modal></app-login-modal>
}
<app-header></app-header>
<router-outlet></router-outlet>
<app-stream-certificate></app-stream-certificate>
@if (userPage && holderService.holder !== undefined && holderService.holder.dirty) {
  <app-change-log [strings]="strings.artesStrings"></app-change-log>
}
